import React, { useEffect } from "react";
import {
  Descriptions,
  Breadcrumb,
  PageHeader,
  Tag,
  Empty,
  Timeline,
  Button,
} from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { getReportDetails, updateReportDone } from "../../actions/report";
import { Title, Wrapper } from "./style";
import { Content } from "antd/lib/layout/layout";
import { Link } from "react-router-dom";
import Remarks from "../../component/remark";
import { EditOutlined } from "@ant-design/icons";
const ReportDetails = ({ location, getReportDetails, updateReportDone }) => {
  const [data, setData] = useState(null);

  const [remark, setRemark] = useState(false);

  

  async function fetchData() {
    const id = new URLSearchParams(location.search).get("id");
    const res = await getReportDetails(id);

    setData(res);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleRefresh = async () => {
    const res = await getReportDetails(data?.report_id);

    setData(res);
  };

  const makeLocalTime = (date) => {
    let hours = date?.split("T")[1].split(":")[0];
    let minutes = date?.split("T")[1].split(":")[1];
    var am = true;
    if (hours > 12) {
      am = false;
      hours -= 12;
    } else if (hours === 12) {
      am = false;
    } else if (hours === 0) {
      hours = 12;
    }
    return (
      date?.split("T")[0] +
      "," +
      hours +
      ":" +
      minutes +
      " " +
      (am ? "A.M" : "P.M")
    );
  };

  return (
    <Content style={{ margin: "0 16px" }}>
      <Breadcrumb style={{ padding: "10px 0px" }}>
        <Breadcrumb.Item>
          <Link to="/dashboard">Home</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Report Details</Breadcrumb.Item>
      </Breadcrumb>

      <PageHeader
        ghost={false}
        onBack={() => window.history.back()}
        title="Report Details"
        subTitle="Report Management"
      ></PageHeader>

      <Wrapper>
        <h2>Product Name : {data?.product_name}</h2>

        <Tag color="#c237a4">ID: {data?.report_id}</Tag>
        {data?.status !== "active" ? (
          <Tag color="#6fcf20">Status: Done</Tag>
        ) : (
          <Tag color="#a7d820">Status: Active</Tag>
        )}
        {data?.invalid_code ? <Tag color="#e48435">Invalid Code'</Tag> : null}
        <Tag color="#c237a4">{data?.created_at}</Tag>
        {data?.status === "active" ? (
          <Button
            size="small"
            type="primary"
            style={{ float: "right" }}
            icon={<EditOutlined />}
            onClick={() => {
              setRemark(true);
            }}
          >
            Make Done
          </Button>
        ) : null}
        <br />
        <br />

        {data ? (
          <>
            <Title>Report Details </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="ID">
                <strong>{data?.report_id}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="PRODUCT NAME">
                <strong>{data?.product_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="ADDRESS">
                <strong>{data?.address}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="IP">
                <strong>{data?.ip}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="COORDINATE">
                <strong>
                  {data?.coordinate[1]}, {data?.coordinate[0]}
                </strong>
              </Descriptions.Item>
              <Descriptions.Item label="SCANED CODE">
                <strong>{data?.scan_code}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="FAKEBUZZ CODE">
                <strong>
                  {data?.invalid_code ? (
                    <Tag color="#d63f12">Invalid</Tag>
                  ) : (
                    <Tag color="#6fcf20">Valid</Tag>
                  )}
                </strong>
              </Descriptions.Item>

              <Descriptions.Item label="Description">
                <strong>{data?.description}</strong>
              </Descriptions.Item>
            </Descriptions>

            <Title>Client Details </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="FIRST NAME">
                <strong>{data?.client?.first_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="LAST NAME">
                <strong>{data?.client?.last_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="BRAND NAME">
                <strong>{data?.client?.brand_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="EMAIL">
                <strong>{data?.client?.email}</strong>
              </Descriptions.Item>
            </Descriptions>
            {data?.invalid_code ? null : (
              <>
                <Title>Code Details </Title>
                <br />
                <Descriptions>
                  <Descriptions.Item label="CODE ID">
                    <strong>{data?.code?.code_id}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="PRODUCT NAME">
                    <strong>{data?.code?.product_name}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="BRAND NAME">
                    <strong>{data?.code?.brand_name}</strong>
                  </Descriptions.Item>
                  <Descriptions.Item label="THUMBNAIL">
                    <img
                      src={`${process.env.REACT_APP_API_BASE_URL}/files/${data?.code?.product_thumbnail}`}
                      width="40px"
                      height="40px"
                      style={{
                        boxShadow: "-2px 2px 34px -8px rgba(0,0,0,0.54)",
                      }}
                      alt="thumbnail"
                    />
                  </Descriptions.Item>
                </Descriptions>
              </>
            )}

            <Title> App User Details </Title>
            <br />
            <Descriptions>
              <Descriptions.Item label="FIRST NAME">
                <strong>{data?.app_user?.first_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="LAAST NAME">
                <strong>{data?.app_user?.last_name}</strong>
              </Descriptions.Item>
              <Descriptions.Item label="MOBILE">
                <strong>{data?.app_user?.mobile_number}</strong>
              </Descriptions.Item>
            </Descriptions>

            <Title>Logs </Title>
            <br />
            {data?.logs ? (
              <Timeline mode="left">
                {data.logs.map((item, index) => (
                  <Timeline.Item
                    label={makeLocalTime(item?.created_at)}
                    keys={index}
                  >
                    {item?.message}
                  </Timeline.Item>
                ))}
              </Timeline>
            ) : (
              <Empty />
            )}
          </>
        ) : null}
        <br />
        <br />
      </Wrapper>
      <Remarks
        title=" "
        btn="Submit"
        placement="bottom"
        visible={remark}
        fnc={() => setRemark(false)}
        id={data?.report_id}
        delFnc={updateReportDone}
        refresh={handleRefresh}
      />
      
    </Content>
  );
};

export default connect(null, {
  getReportDetails,
  updateReportDone,
 
})(ReportDetails);
